// A page-owned assertion only; the server verifies membership for every request.
export function workspaceAssertion(path) {
  const match = /^\/([a-z0-9]{1,8})\/crm(?:\/|$)/i.exec(path || '');
  return match ? match[1].toUpperCase() : null;
}

export function workspaceCacheOwner(owner, path) {
  const workspace = workspaceAssertion(path);
  return workspace ? `${workspace}:${String(owner || "")}` : String(owner || "");
}

export function workspacePrefix(path) {
  const code = workspaceAssertion(path);
  return code ? `/${code}/crm` : "";
}

export function workspaceUrl(url, path) {
  const prefix = workspacePrefix(path);
  return prefix && /^\/(?:api(?:\/|$)|app(?:\/|$)|login(?:[?/#]|$)|monaco\/)/.test(url || "") ? prefix + url : url;
}
